export default class ItemRegistroTiempo {
    Id: string;
    CodigoCliente: string;
    IdUsuario: string;
    IdOrden: number;
    IdTarea: number;
    Inicio: string;
    Fin: string;
    Descripcion: string;
    FechaAlta: string;
    FechaAltaReal: string;
    TiempoEmpleado: number;
    FechaUltimaModificacion: string;
    Estado: number;
    ModoRegistro: number;
    Descargado: boolean;
    IdMarcaje: string;
    PosicionGPSInicio: string;
    PosicionGPSFinal: string;
    TipoTrabajo: string;
    DireccionInicio: string;
    DireccionFinal: string;

    constructor() {
        this.Id ="";
        this.CodigoCliente = "";
        this.IdUsuario = "";
        this.IdOrden = 0;
        this.IdTarea = 0;
        this.Inicio = "";
        this.Fin = "";
        this.Descripcion = "";
        this.FechaAlta = "";
        this.FechaAltaReal = "";
        this.TiempoEmpleado = 0;
        this.FechaUltimaModificacion = "";
        this.Estado = 0;
        this.ModoRegistro = 0;
        this.Descargado = false;
        this.IdMarcaje = "";
        this.PosicionGPSInicio = "";
        this.PosicionGPSFinal = "";
        this.TipoTrabajo = "";
        this.DireccionInicio = "";
        this.DireccionFinal = "";
    };
};
